import { useCallback } from 'react';
import { IBannerInfo, IBannerItem } from '@/types';
import { Banner } from '@/components/atoms';
import { Wrapper } from '@/components/templates/collectBanner/CollectBanner.styled';
import { IntersectionObserver } from '@/components/common';
import { clickEventHandler } from '@/helpers';
import { useCommonParams, useLoading } from '@/hooks';

const CollectBanner = (props: IBannerInfo) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [, setLoading] = useLoading();

  const handleClick = useCallback(
    async (item: IBannerItem) => {
      await clickEventHandler({ ...item, ...commonParams, setLoading });
    },
    [commonParams, setLoading],
  );

  const renderComponent = (item: IBannerItem, index: number) => (
    <IntersectionObserver key={index} page={commonParams.page} {...item}>
      <Banner
        src={item.imgPath}
        alt={item.destinationUrl || ''}
        onClick={() => handleClick(item)}
      />
    </IntersectionObserver>
  );

  return (
    <Wrapper>
      {ads.length > 0 &&
        ads.map((item: IBannerItem, index: number) => renderComponent(item, index))}
    </Wrapper>
  );
};

export default CollectBanner;
